import React from 'react'
import { connect } from 'react-redux'
import { doGetAttendanceRecord } from '../../reducers/actions'
class AttendanceRecordDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }
    componentDidMount = () => {
        this.doGetAttendanceRecord()
    }

    doGetAttendanceRecord = () => {
        const { dispatch, id } = this.props
        dispatch(doGetAttendanceRecord({
            id: id || 0,
            onEnd: ({ errorMessage, initValues基本信息, }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, })
                }
            }
        }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    handlerReGet = () => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'ReGetAttendanceRecord',
            data: { id },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('获取成功')
                    this.doGetAttendanceRecord()
                }
            }
        })

    }

    fieldset基本信息 = () => {
        return [
            { _date: '日期', minWidth: '95%', disabled: true },
            {
                _grid: '', name: '出勤记录', rowNumbers: true, minRows: 12,/*  maxRows: 11, */ height: '100%', minWidth: '95%',
                columns: [
                    { _text: '姓名', flex: 1 },
                    { _text: '上班', flex: 1, renderer: (that, { data }) => <span style={{ 'color': data.上班异常 ? 'red' : 'green', }} > {data.上班} </span>, },
                    { _text: '下班', flex: 1, renderer: (that, { data }) => <span style={{ 'color': data.下班异常 ? 'red' : 'green', }} > {data.下班} </span> },
                    { _text: '假勤', flex: 1 },
                ],
                buttons: [
                ],
            },
            {
                _group: '', minWidth: '95%', items: [
                    { _label: '█', minWidth: '2em', style: { 'color': 'green' }, margin: '0 5 0 0', align: 'right' },
                    { _label: '出勤', minWidth: '50', flex: 2, margin: '0' },
                    { _label: '█', minWidth: '2em', style: { 'color': 'red' }, margin: '0 5 0 0', align: 'right' },
                    { _label: '迟到/早退', minWidth: '50', flex: 2, margin: '0' },
                    { _label: '', flex: 15 }
                ]
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { bReGet } = initValues基本信息
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _button: '重新获取', icon: 'share', handler: () => this.handlerReGet(), cdt: () => bReGet },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '出勤记录', name: '基本信息', _fieldset: this.fieldset基本信息(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(AttendanceRecordDetail)